<mat-icon *ngIf="iconSvg; else imgTag" [svgIcon]="iconSvg" [class]="styleClass">
</mat-icon>

<ng-template #imgTag>
  <div class="-mt-1">
    <img *ngIf="imgSrc" [src]="imgSrc" style="width: 30px; height: 30px" />
  </div>
</ng-template>
